import { defineAbility } from "@casl/ability";

export default defineAbility((can) => {
  // access test for dev
  can("access_test_for_dev");
});
